import pick from 'lodash/pick';

import { Customer, CustomerInput, DeepPartial } from '~src/model';
import { DeepNullToUndefined, deepNullToUndefined } from '~src/util';

type CustomerInfo = Pick<Customer, 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'notes'> &
  Partial<Pick<Customer, 'id'>>;

export type CustomerDetails = CustomerInfo &
  Pick<Customer, 'financingProvider' | 'newsletter'> & {
    allowDataStorage?: boolean | null;
  };

export const toCustomerInput = (
  customer?: DeepPartial<Customer> & Pick<CustomerInput, 'googleClickId' | 'scoringFields' | 'utmFields'>,
  inputID?: string | number
): { customer: DeepNullToUndefined<CustomerInput> } => {
  const { id = inputID } = customer ?? {};

  return {
    customer: {
      ...deepNullToUndefined(
        pick(customer ?? {}, [
          'email',
          'financingProvider',
          'firstName',
          'lastName',
          'notes',
          'phoneNumber',
          'googleClickId',
          'scoringFields',
          'utmFields',
        ])
      ),
    },
    ...(id ? { id: Number(id) } : {}),
  };
};
